<template>
  <!-- 头部整体盒子 -->
  <div id="header">
    <!-- 电脑导航 -->
    <div class="header-nav hg-page-width hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/brand-logo.svg" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
        >
          <a @click="goToTarget(index)">{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <img style="width:105px;height:24px;margin-left:12px;" src="@/assets/img/brand-logo.svg" alt="">
        <div
          :class="{
            'header-nav-m-menu-wrapper': true,
            _menu_wrap_toopen: menuState,
            _menu_wrap_toclose: !menuState,
          }"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      menuState: true,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "index",
          children: [],
        },
        {
          name: "品牌故事",
          path: "brand",
          children: [],
        },
        {
          name: "企业产品",
          path: "product",
          children: [],
        },
        {
          name: "官方商城",
          path: "product",
          children: [],
        },
        {
          name: "关于我们",
          path: "brand",
          children: [],
        },
      ],
    };
  },
  methods: {
    goToTarget(index) {
      this.navIndex = index;
      this.$store.commit("SET_INDEX_PAGE_POS", index);
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      this.menuState = !this.menuState;
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* 顶部 */
@import "../assets/css/common.css";
.baseHeader {
  height: 60px;
}
/** iPhone **/
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .baseHeader {
    height: 50px;
  }
}
#header {
  @extend .baseHeader;
  background: #f4f4f4;
  transition: all ease 0.6s;
  position: fixed;
  width: 100%;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: saturate(180%) blur(10px);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 100%;
  padding: 0px 8px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  flex: 1;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 95px;
  height: 45px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
  cursor: pointer;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #000;
  text-decoration: none;
  border-bottom: 2px solid #000;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
    width: 100%;
  }
  /* 导航栏logo容器 */

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #000;
    height: 100%;
    font-size: 20px;
    line-height: 50px;
    background: transparent;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 37px;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #000;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
._menu_wrap_toopen {
  background: url(../assets/img/menu.png) no-repeat center;
}
._menu_wrap_toclose {
  background: url(../assets/img/close.png) no-repeat center;
}
.glyphicon-menu-down:before,
.glyphicon-menu-up:before {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue